export var MethodType;
(function (MethodType) {
    MethodType[MethodType["getter"] = 0] = "getter";
    MethodType[MethodType["setter"] = 1] = "setter";
})(MethodType || (MethodType = {}));
export var getMethodPrefix = function (type) {
    if (type === MethodType.getter) {
        return "get";
    }
    else if (type === MethodType.setter) {
        return "set";
    }
    else {
        return "";
    }
};
export var isEmpty = function (value) {
    return value === undefined || value === null || value === "";
};
export var Property = function (setter, getter, isPramArr, paramResolve) {
    return function (target, propertyName) {
        var methods = {
            setter: setter,
            getter: getter,
            isPramArr: isPramArr,
            paramResolve: paramResolve
        };
        if (!target.propDic) {
            target.propDic = {};
        }
        target.propDic[propertyName] = methods;
    };
};
export var IMCtrl = "__imricheditor";
export function isEqual(value, other) {
    if (typeof value === "string") {
        return value === other;
    }
    if (typeof value === "boolean") {
        return value === other;
    }
    if (typeof value === "number") {
        return value === other;
    }
    if (typeof value === "undefined") {
        return typeof other === "undefined";
    }
    // Get the value type
    var type = Object.prototype.toString.call(value);
    // If the two objects are not the same type, return false
    if (type !== Object.prototype.toString.call(other))
        return false;
    if (isDate(value) && isDate(other)) {
        return isEqual(value.toUTCString(), other.toUTCString());
    }
    // If items are not an object or array, return false
    if (['[object Array]', '[object Object]'].indexOf(type) < 0)
        return false;
    // Compare the length of the length of the two items
    var valueLen = type === '[object Array]' ? value.length : Object.keys(value).length;
    var otherLen = type === '[object Array]' ? other.length : Object.keys(other).length;
    if (valueLen !== otherLen)
        return false;
    // Compare two items
    var compare = function (item1, item2) {
        // Get the object type
        var itemType = Object.prototype.toString.call(item1);
        // If an object or array, compare recursively
        if (['[object Array]', '[object Object]'].indexOf(itemType) >= 0) {
            if (!isEqual(item1, item2))
                return false;
        }
        // Otherwise, do a simple comparison
        else {
            // If the two items are not the same type, return false
            if (itemType !== Object.prototype.toString.call(item2))
                return false;
            // Else if it's a function, convert to a string and compare
            // Otherwise, just compare
            if (itemType === '[object Function]') {
                if (item1.toString() !== item2.toString())
                    return false;
            }
            else {
                if (item1 !== item2)
                    return false;
            }
        }
    };
    // Compare properties
    if (type === '[object Array]') {
        for (var i = 0; i < valueLen; i++) {
            if (compare(value[i], other[i]) === false)
                return false;
        }
    }
    else {
        for (var key in value) {
            if (value.hasOwnProperty(key)) {
                if (compare(value[key], other[key]) === false)
                    return false;
            }
        }
    }
    // If nothing failed, return true
    return true;
}
;
function isDate(value) {
    return Object.prototype.toString.call(value) === '[object Date]';
}
